;(() => {
	const sliders = new WeakMap()
	const observedSections = new WeakSet()

	const initSlider = (section) => {
		const slider = section.querySelector('.swiper--image-columns')
		if (!slider) return

		const existing = sliders.get(slider)
		if (existing) {
			// The theme editor can morph the section DOM in place, wiping Swiper's
			// classes while this instance survives — detect and rebuild instead of bailing
			if (slider.classList.contains('swiper') && slider.swiper === existing) return
			try {
				existing.destroy(true, true)
			} catch (error) {
				// instance already torn down with the old DOM
			}
			sliders.delete(slider)
		}

		const wrapper = slider.querySelector('.image-columns__wrapper')
		const slides = slider.querySelectorAll('.image-columns__item')
		if (!wrapper || slides.length < 2) return

		slider.classList.add('swiper')
		wrapper.classList.add('swiper-wrapper')
		slides.forEach((slide) => slide.classList.add('swiper-slide'))

		const rootStyles = getComputedStyle(slider.closest('.image-columns'))
		const gap = parseInt(rootStyles.getPropertyValue('--gap')) || 20
		const mobileColumns = parseFloat(rootStyles.getPropertyValue('--mobile-count')) || 1
		const desktopColumns = parseInt(rootStyles.getPropertyValue('--count')) || 5

		const params = {
			loop: false,
			speed: 800,
			breakpoints: {
				320: {
					slidesPerView: mobileColumns,
					slidesPerGroup: Math.max(1, Math.floor(mobileColumns)),
					spaceBetween: gap,
				},
				750: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: gap,
				},
				990: {
					slidesPerView: desktopColumns,
					slidesPerGroup: desktopColumns,
					spaceBetween: gap,
				},
			},
		}

		const prevButton = slider.querySelector('.image-columns__button--prev')
		const nextButton = slider.querySelector('.image-columns__button--next')
		if (prevButton && nextButton) {
			params.navigation = { prevEl: prevButton, nextEl: nextButton }
		}

		const pagination = slider.querySelector('.image-columns__pagination')
		if (pagination) {
			const bulletLabel = pagination.dataset.slideLabelTemplate || 'Go to slide __n__'

			if (!pagination.dataset.keyboardBound) {
				pagination.dataset.keyboardBound = 'true'
				pagination.addEventListener('keydown', (event) => {
					if (event.key !== 'Enter' && event.key !== ' ') return
					const bullet = event.target.closest('.swiper-pagination-bullet')
					if (!bullet) return
					event.preventDefault()
					bullet.click()
				})
			}

			params.pagination = {
				el: pagination,
				clickable: true,
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					let out = ''
					for (let i = 1; i < total + 1; i++) {
						const activeClass = i == current ? ' swiper-pagination-bullet-active' : ''
						out = `${out}<span class="swiper-pagination-bullet${activeClass}" tabindex="0" role="button" aria-label="${bulletLabel.replace('__n__', i)}"></span>`
					}
					return out
				},
			}
		}

		sliders.set(slider, new Swiper(slider, params))
	}

	const destroySlider = (section) => {
		const slider = section.querySelector('.swiper--image-columns')
		if (!slider) return

		const swiper = sliders.get(slider)
		if (swiper) {
			swiper.destroy(true, true)
			sliders.delete(slider)
		}

		slider.classList.remove('swiper')
		const wrapper = slider.querySelector('.image-columns__wrapper')
		if (wrapper) wrapper.classList.remove('swiper-wrapper')
		slider.querySelectorAll('.image-columns__item').forEach((slide) => {
			slide.classList.remove('swiper-slide')
			slide.removeAttribute('style')
		})
	}

	const setupSlider = (section) => {
		const slider = section.querySelector('.swiper--image-columns')
		if (!slider) return

		// window.innerWidth (not the section width) so the JS breakpoint agrees with the CSS media queries when a classic scrollbar is present
		const wantsCarousel =
			window.innerWidth < 990
				? slider.hasAttribute('data-carousel-mobile')
				: slider.hasAttribute('data-carousel-desktop')

		if (wantsCarousel) {
			initSlider(section)
		} else {
			destroySlider(section)
		}
	}

	const initSection = (section) => {
		if (!section || !section.classList.contains('image-columns-section')) return

		if (!observedSections.has(section)) {
			observedSections.add(section)
			const sectionResizeObserver = new ResizeObserver(() => setupSlider(section))
			sectionResizeObserver.observe(section)
		}

		setupSlider(section)
	}

	initSection(document.currentScript.parentElement)

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
	})
})()
